"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
exports.isNonEmptyArray = isNonEmptyArray;
//# sourceMappingURL=arrays.js.map